import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  fetchFutureProducts,
  fetchFutureDashboard,
  deleteFutureProduct,
  launchFutureProduct
} from './futureProductsApi';

export function useFutureProducts() {
  return useQuery({
    queryKey: ['future-products', 'list'],
    queryFn: fetchFutureProducts,
    refetchInterval: 8000
  });
}

export function useFutureDashboard() {
  return useQuery({
    queryKey: ['future-products', 'dashboard'],
    queryFn: fetchFutureDashboard,
    refetchInterval: 8000
  });
}

export function useFutureMutations() {
  const qc = useQueryClient();
  const invalidate = () => {
    qc.invalidateQueries({ queryKey: ['future-products'] });
    // the "IN FUTURE" marker + remaining-material live on the orders queries — refresh
    // them too so deleting/launching a future product updates them in real time.
    qc.invalidateQueries({ queryKey: ['orders'] });
  };

  const remove = useMutation({
    mutationFn: deleteFutureProduct,
    onSuccess: invalidate
  });
  const launch = useMutation({
    mutationFn: launchFutureProduct,
    onSuccess: () => {
      invalidate();
      qc.invalidateQueries({ queryKey: ['jobs'] }); // it's a real job now
    }
  });
  return { remove, launch };
}
